module.exports = __webpack_public_path__ + "static/media/dynamic_schedules_preview.521b8b5d.PNG";